import PropTypes from 'prop-types';

import FloatingInput from '#/modules/commonComponents/form/FloatingInput';
import { getPhaseRemaining } from '#/modules/crmMgmt/customerOrder/helper/collection';
import { formatDisplayAmount } from '#/utils/formatNumber';

/** 期別抵付輸入：每期一列，顯示未抵付額。`credits` 以 phaseId 對應。 */
const CollectionCreditsEditor = ({ summaryPhases, credits, onChange, idPrefix }) => {
  const byId = new Map(credits.map((credit) => [credit.phaseId, credit.amount]));

  function setAmount(phaseId, amount) {
    const others = credits.filter((credit) => credit.phaseId !== phaseId);
    onChange([...others, { phaseId, amount }]);
  }

  return (
    <div className="space-y-1.5">
      <p className="text-sm text-slate-600">抵付期別（未抵付部分保留為未分配餘額）</p>
      {getPhaseRemaining(summaryPhases).map((phase) => (
        <div key={phase.phaseId} className="grid grid-cols-[4rem_1fr_9rem] items-center gap-2">
          <span className="text-sm">第 {phase.phaseNo} 期</span>
          <span className="text-xs text-slate-500">
            約定 {formatDisplayAmount(phase.contractedAmount)}・未抵付 {formatDisplayAmount(phase.remaining)}
          </span>
          <FloatingInput
            id={`${idPrefix}-${phase.phaseId}`}
            type="number"
            label="抵付金額"
            min={0}
            step="0.01"
            value={String(byId.get(phase.phaseId) ?? '')}
            onChange={(event) => setAmount(phase.phaseId, event.target.value)}
            suppressInlineError
          />
        </div>
      ))}
    </div>
  );
};

CollectionCreditsEditor.propTypes = {
  summaryPhases: PropTypes.arrayOf(PropTypes.object).isRequired,
  credits: PropTypes.arrayOf(PropTypes.shape({
    phaseId: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  idPrefix: PropTypes.string.isRequired,
};

export default CollectionCreditsEditor;
